'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarText = exports.SidebarLogo = exports.SidebarWrapper = exports.SidebarContent = exports.SidebarContainer = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarContainer = exports.SidebarContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Sidebarstyles__SidebarContainer'
})(['display:none;height:auto;flex:1;flex-flow:column nowrap;align-items:center;padding:85px 50px 50px 50px;@media (min-width:768px){display:flex;}']);

var SidebarContent = exports.SidebarContent = _styledComponents2.default.div.withConfig({
  displayName: 'Sidebarstyles__SidebarContent'
})(['flex:1;display:flex;color:white;margin:auto;align-items:center;']);

var SidebarWrapper = exports.SidebarWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Sidebarstyles__SidebarWrapper'
})(['flex:1;max-width:350px;margin:0 auto 0 auto;']);

var SidebarLogo = exports.SidebarLogo = _styledComponents2.default.img.withConfig({
  displayName: 'Sidebarstyles__SidebarLogo'
})(['position:static;width:90px;top:30px;left:50%;margin:0 0 30px;']);

var SidebarText = exports.SidebarText = _styledComponents2.default.div.withConfig({
  displayName: 'Sidebarstyles__SidebarText'
})(['display:flex;align-items:center;font-size:22px;line-height:1.5em;text-align:center;']);